export enum TrackingItemState {
	NotStarted = 1,
	InProgress = 2,
	Completed = 3
}